import { render, staticRenderFns } from "./SmallTagGroup.vue?vue&type=template&id=517d602c&"
import script from "./SmallTagGroup.vue?vue&type=script&lang=js&"
export * from "./SmallTagGroup.vue?vue&type=script&lang=js&"
import style0 from "./SmallTagGroup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports